import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const Header = ({title, titleColor = 'black', titleFontFamily, titleTag, titleAlignment}) => {
    return (
        title && (
            <Box
                marginTop={{base: '20px', md: '30px', lg: '40px'}}
                paddingX={{base: '15px', lg: '20px', '2xl': '40px'}}
            >
                <Text
                    as={titleTag}
                    fontFamily={titleFontFamily}
                    color={titleColor}
                    fontSize={{base: '29px', lg: '40px'}}
                    letterSpacing={{base: '0.145px', lg: '0.2px'}}
                    fontWeight="400"
                    lineHeight="normal"
                    textAlign={titleAlignment}
                >
                    {title}
                </Text>
            </Box>
        )
    )
}

Header.propTypes = {
    title: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleTag: PropTypes.string,
    titleColor: PropTypes.string,
    titleAlignment: PropTypes.string
}

export default Header
